import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userTimetracking: {},
  allUserTimeTracking: [],
  userTimeTrackingByTicket: [],
  userTimeTrackingByWorklog: [],
  userTimeTrackingForTicketsByDates: [],
  userTimeTrackingByWorklogForDay: [],
  epicTimeTracking: {},
  allBoardsTimeTracking: [],
  projectBoardTimeTrackingByTicket: [],
  projectBoardTimeTrackingByEpic: [],
  allCustomersProjectBoardsTimeTracking: [],
  customerProjectBoardTimeTrackingByTicket: [],
  generateExcelSpreadsheet: {},
  generateTicketExcelSpreadsheet: {},
  generateTimeCard: {},
  error: [],
  userTimeTrackingByTicketByDate: null,
  userEpicTimeTrackingByMonth: null,
  customerProjectBoardTimeTracking: null,
  isLoading: false,
  toggleModal: false,
  toggleWorklogModal: false,
  quickbooksData: [],
  timeTrackingData: [],
};

const quickbookSlice = createSlice({
  name: 'quickbook',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = [];
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.error;
      state.isLoading = false;
    },
    setWorklogDetails: (state, action) => {
      state.worklogDetails = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setUserTimetracking: (state, action) => {
      state.userTimetracking = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setGenerateTicketExcelSpreadsheet: (state, action) => {
      state.generateTicketExcelSpreadsheet = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setAllUserTimeTracking: (state, action) => {
      state.allUserTimeTracking = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setGenerateExcelSpreadsheet: (state, action) => {
      state.generateExcelSpreadsheet = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setUserTimeTrackingByTicketByDate: (state, action) => {
      state.userTimeTrackingByTicketByDate = action.payload; //
      state.error = [];
      state.isLoading = false;
    },
    setUserTimeTrackingByWorklog: (state, action) => {
      state.userTimeTrackingByWorklog = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setUserTimeTrackingByWorklogForDay: (state, action) => {
      state.userTimeTrackingByWorklogForDay = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setUserTimeTrackingForTicketsByDates: (state, action) => {
      state.userTimeTrackingForTicketsByDates = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setEpicTimeTracking: (state, action) => {
      state.epicTimeTracking = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setUserEpicTimeTrackingByMonth: (state, action) => {
      state.userEpicTimeTrackingByMonth = action.payload; //
      state.error = [];
      state.isLoading = false;
    },
    setAllBoardsTimeTracking: (state, action) => {
      state.allBoardsTimeTracking = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setProjectBoardTimeTrackingByTicket: (state, action) => {
      state.projectBoardTimeTrackingByTicket = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setProjectBoardTimeTrackingByEpic: (state, action) => {
      state.projectBoardTimeTrackingByEpic = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setAllCustomersProjectBoardsTimeTracking: (state, action) => {
      state.allCustomersProjectBoardsTimeTracking = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setCustomerProjectBoardTimeTracking: (state, action) => {
      state.customerProjectBoardTimeTracking = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setGenerateTimeCard: (state, action) => {
      state.generateTimeCard = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setGenerateReport: (state, action) => {
      state.generateReport = action.payload; // state not found
      state.error = [];
      state.isLoading = false;
    },
    setToggleModal: (state, action) => {
      state.toggleModal = !state.toggleModal;
    },
    setToggleWorklogModal: (state, action) => {
      state.toggleWorklogModal = !state.toggleWorklogModal;
    },
    setResetCsvFile: (state, action) => {
      state.generateTimeCard = {};
      state.generateExcelSpreadsheet = {};
      state.generateTicketExcelSpreadsheet = {};
    },
    setResetQuickBooks: () => {
      return initialState;
    },
    setQuickbooksData: (state, action) => {
      state.quickbooksData = action.payload;
      state.error = [];
      state.isLoading = false;
    },
    setTimeTrackingData: (state, action) => {
      state.timeTrackingData = action.payload;
      state.error = [];
      state.isLoading = false;
    },
  },
});

export const {
  start,
  setReducerError,
  setWorklogDetails,
  setUserTimetracking,
  setGenerateTicketExcelSpreadsheet,
  setAllUserTimeTracking,
  setGenerateExcelSpreadsheet,
  setUserTimeTrackingByTicketByDate,
  setUserTimeTrackingByWorklog,
  setUserTimeTrackingByWorklogForDay,
  setUserTimeTrackingForTicketsByDates,
  setEpicTimeTracking,
  setUserEpicTimeTrackingByMonth,
  setAllBoardsTimeTracking,
  setProjectBoardTimeTrackingByTicket,
  setProjectBoardTimeTrackingByEpic,
  setAllCustomersProjectBoardsTimeTracking,
  setCustomerProjectBoardTimeTracking,
  setGenerateTimeCard,
  setGenerateReport,
  setToggleModal,
  setToggleWorklogModal,
  setResetCsvFile,
  setResetQuickBooks,
  setQuickbooksData,
  setTimeTrackingData,
} = quickbookSlice.actions;

export default quickbookSlice.reducer;
